import React from 'react'
import PageHeader from '../components/PageHeader'

const Green_Initiative = () => {
    return (
        <div>
            <PageHeader title="Green Initiative" />
        </div>
    )
}

export default Green_Initiative